var text_title ="Overlay text";
var imageLoader = document.getElementById('imageLoader');
    imageLoader.addEventListener('change', handleImage, false);
var canvas = document.getElementById('canvas');
var ctx = canvas.getContext('2d');
var img = new Image();
img.crossOrigin="anonymous";

window.addEventListener('load', DrawPlaceholder)

function DrawPlaceholder() {
    img.onload = function() {
        DrawOverlay(img);
        DrawText();
        DynamicText(img)
    };
    
  
}
function DrawOverlay(img) {
    ctx.drawImage(img,0,0);
    ctx.fillStyle = 'rgba(235, 162, 192, 0.10)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
}
function DrawText() {
    ctx.fillStyle = "#000";
    ctx.textBaseline = 'middle';
    ctx.font = "50px 'Montserrat'";
    ctx.fillText(text_title, 50, 50);
}
function DynamicText(img) {
  document.getElementById('name').addEventListener('keyup', function() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    DrawOverlay(img);
    DrawText(); 
    text_title = this.value;
    ctx.fillText(text_title, 50, 50);
    var imgData = canvas.toDataURL();
    alert(imgData);
    $('#textarea').text(imgData);
    $('#nav-next').removeClass('hide');
    $('label.canvauploadbtn').addClass('deactive');
  });
}
function handleImage(e) {
    var reader = new FileReader();
    var img = "";
    var src = "";
    reader.onload = function(event) {
        img = new Image();
        img.onload = function() {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img,0,0);
        }
        img.src = event.target.result;
        src = event.target.result;
        canvas.classList.add("show");
        DrawOverlay(img);
        DrawText(); 
        DynamicText(img);   
    }

    reader.readAsDataURL(e.target.files[0]); 
 
}
function convertToImage() {
	window.open(canvas.toDataURL('png'));
}




//



$("input#name").keyup(function(){

  var csttet = $(this).val();
  $('input.custo-text').val(csttet);
$('input#your-name').val(csttet);
  
  $('a#nav-next').removeClass('hide');

});

$("input#age").keyup(function(){

  var age = $(this).val();
  $('input.custo-text-age').val(age);
  $('input#your-age').val(age);
 // $('a#nav-next').removeClass('hide');

});

$("input#distance").keyup(function(){

  var distance = $(this).val();
  $('input.custo-text-distance').val(distance);
  $('input#your-distance').val(distance);
 // $('a#nav-next').removeClass('hide');

});

$("input#gender").keyup(function(){

  var gender = $(this).val();
  $('input.custo-text-gender').val(gender);
   $('input#your-gender').val(gender);
  $('a#nav-next').removeClass('hide');

});



$("input#Quantity").keyup(function(){
  var quantity = $(this).val();
  if(quantity < 200){

    $('.custom-form-shopify').removeClass('hide');
    $('.product-form__cart-submit').addClass('hide');

  }

  if( quantity > 199 ){

    $('.custom-form-shopify').addClass('hide');
    $('.product-form__cart-submit').removeClass('hide');

  }


  if( quantity > 5000 ){

    $('.custom-form-shopify').removeClass('hide');
    $('.product-form__cart-submit').addClass('hide');

  }

});

// $("Quantity").on('change',function(){
// var quantity = $(this).val();
//   if(quantity < 200){

//     $('.custom-form-shopify').removeClass('hide');
//     $('.product-form__cart-submit').addClass('hide');
//   }

//   if(quantity > 199){

//     $('.custom-form-shopify').addClass('hide');
//      $('.product-form__cart-submit').removeClass('hide');
//   }
// });

$("input[type=file]").on('change',function(){
 // alert($(this).val());
  $('.avatar-upload').addClass('showdummy');
  $('h4.hide').removeClass('hide');
  
  $('input.custo-text.hide').removeClass('hide');
  $('input.custo-text-age.hide').removeClass('hide');
  $('input.custo-text-distance.hide').removeClass('hide');
  $('input.custo-text-gender.hide').removeClass('hide');
  $('.frame-text.hide').removeClass('hide');
  
  $('.first-image-main').addClass('hide');
  $('#canvas-wrap').removeClass('hidden');
  $('canvas#canvas').addClass('removeborder');
  $('.buble-1, .buble-2, .buble-3, .buble-4').addClass('hide');
  $('.step-1').trigger('click');
  setTimeout(function(){
    var dataimg = $('textarea#textarea').text();
console.log(dataimg);
    if(dataimg){
      $('label.canvauploadbtn').addClass('deactive');

    }
  }, 300);
});



$("a#nav-next").click(function(){
  $('.step-1').removeClass('active');
  $('.step-2').addClass('active');

  $('.step-2').attr('preivewadded', '1');
  $('.step-1-content').addClass('hide');
  $('.step-2-content').removeClass('hide');

  $('canvas#canvas').removeClass('removeborder');
  $('.buble-1, .buble-2, .buble-3, .buble-4').removeClass('hide');

});


$(".step-1").click(function(){
  $('.custom-form-shopify').addClass('hide');
  $('.step-1').addClass('active');
  $('.step-2, .step-3, .step-4').removeClass('active');
  $('.step-1-content').removeClass('hide');
  $('.step-2-content').addClass('hide');
   $('.product-form').addClass('hide');
});

$(".step-2-content").click(function(){
  $(this).addClass('hide');
  $('.custom-form-shopify').addClass('hide');
  $('.step-3').attr('step2done', '1');
  
  $('.step-3').addClass('active');
  $('.step-1, .step-2, .step-4').removeClass('active');
  $('.step-1-content').addClass('hide');
  $('.product-form').removeClass('hide');
});



$(".step-2").click(function(){

  var step2attr = $(this).attr('preivewadded');
  if( step2attr =='1' ){
    $('.custom-form-shopify').addClass('hide');
    $(this).addClass('active');
    $('.step-1-content').addClass('hide');
    $('.step-1, .step-3, .step-4').removeClass('active');
    $('.product-form').addClass('hide');
    $('.step-2-content').removeClass('hide');
  }
});


$(".step-3").click(function(){
  var step2done = $(this).attr('step2done');
  if( step2done =='1' ){

    $('.custom-form-shopify').addClass('hide');
    $(this).addClass('active');
    $('.step-1-content').addClass('hide');
    $('.step-1, .step-2, .step-4').removeClass('active');
    $('.product-form').removeClass('hide');
    $('.step-2-content').addClass('hide');
  }
});

$(".product-form__cart-submit").click(function(){
  $('.step-4').addClass('active');
  $('.step-1, .step-2, .step-3').removeClass('active');
  var imgsrc = $('input#imageUpload').val();
  //alert(imgsrc)
  $('.customimage').val(imgsrc);
});








function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      $('#imagePreview').css('background-image', 'url('+e.target.result +')');
      $('#imagePreview').hide();
      $('#imagePreview').fadeIn(650);
    }
    reader.readAsDataURL(input.files[0]);
  }
}
$("#imageUpload").change(function() {
  readURL(this);
});